// Polish language pack
// Note: All keys are in Simplified Chinese, values are in Polish
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Aktywa Platformy',
    '质押金额': 'Kwota Hashrate',
    '算力周期': 'Okres Obliczeniowy',
    '天': 'Dni',
    '算力类型': 'Typ Mocy Obliczeniowej',
    '基础算力': 'Computing Podstawowy',
    '高级算力': 'Computing Zaawansowany',
    '超级算力': 'Super Computing',
    '企业算力': 'Computing Korporacyjny',
    '高性能': 'Wysoka Wydajność',
    '标准': 'Standard',
    '经济型': 'Ekonomiczny',
    '申请算力': 'Złóż Computing',
    '申请解押': 'Wykup Hashrate',
    '可申请次数': 'Dostępne Wnioski',
    '剩余次数': 'Pozostałe Razy',
    '短算力类型': 'Typ',
    '短算力周期': 'Okres',
    '短预计日收益': 'Dzienny',
    '短剩余次数': 'Pozostalo',
    '短解押记录': 'Wykup',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Oczek.',
    '短成功': 'Sukces',
    '短失败': 'Blad',
    '短完成': 'Zakonc.',
    '超级算力申请': 'Leasing Hashrate',

    '步骤提示租赁': 'Krok 1 Wybierz plan hashrate · Krok 2 Kliknij "Leasing Hashrate"',
    '请选择算力方案': 'Wybierz plan hashrate',
    '请先选择算力方案': 'Najpierw wybierz plan hashrate, a potem kliknij leasing',    '算力收益等级': 'Poziomy Zysku Computing',
    '查看算力收益等级': 'Zobacz Poziomy Zysku',
    '暂无高级算力等级数据': 'Brak danych o poziomach zaawansowanego computing',
    '暂无超级算力等级数据': 'Brak danych o poziomach super computing',

    // Strona Szczegółów Aplikacji Computing
    '算力详情': 'Szczegóły Computing',
    '基本信息': 'Podstawowe Informacje',
    '原押金额': 'Pierwotna Kwota Stawki',
    '每日收益记录': 'Dzienne Rekordy Zarobków',
    '暂无数据': 'Brak Dostępnych Danych',

    // Computing details
    '算力类型标签': 'Typ:',
    '算力周期标签': 'Okres:',
    '算力类型：': 'Typ:',
    '算力周期：': 'Okres:',
    '预计收益：': 'Zarobki:',
    '质押要求：': 'Postawienie:',
    '开始时间：': 'Start:',
    '结束时间：': 'Koniec:',
    '立即申请': 'Złóż Teraz',

    // Status and prompts
    '申请中...': 'Ładowanie...',
    '申请中': 'Ładowanie...',
    '申请成功': 'Pomyślny',
    '申请失败': 'Niepowodzenie',
    '申请失败，请重试': 'Aplikacja nie powiodła się, spróbuj ponownie',
    '余额不足': 'Niewystarczające Saldo',
    '请先连接钱包': 'Połącz Portfel',
    '算力申请成功！': 'Computing pomyślny!',
    '算力申请失败，请重试': 'Computing niepowodzenie, spróbuj ponownie',
    '申请失败，请先解押已完成的算力订单': 'Wniosek nie powiódł się, najpierw odblokuj ukończone zamówienie mocy obliczeniowej',
    
    // Confirmation dialog
    '确认申请': 'Potwierdź Wniosek',
    '取消': 'Anuluj',
    '确认': 'Potwierdź',
    '您确定要申请此算力吗': 'Złożyć ten computing?',
    '您确定要申请此算力吗？': 'Złożyć ten computing?',
    '申请后将扣除相应的质押金额': 'Kwota zostanie potrącona',
    
    // Computing status
    '运行中': 'Działa',
    '已完成': 'Zakończone',
    '待开始': 'Oczekujące',
    '已取消': 'Anulowane',
    
    // Earnings related
    'USDC': 'USDC',
    '预计日收益': 'Oczekiwane Dzienne Zarobki',
    '总预计收益': 'Całkowite Oczekiwane Zarobki',
    '当前收益': 'Obecne Zarobki',
    
    // Records and status
    '解押申请记录': 'Historia Wykupu',
    '超级算力申请记录': 'Rekordy Wniosków o Super Moc Obliczeniową',
    '全部': 'Wszystkie',
    '待审核': 'Oczekujące',
    '成功': 'Sukces',
    '失败': 'Niepowodzenie',
    '正在加载记录': 'Ładowanie rekordów...',
    '暂无记录': 'Brak rekordów',
    '解押金额': 'Kwota Wykupu',
    '申请天数': 'Dni Wniosku',
    '金额': 'Kwota',

    // Modal related
    '选择周期': 'Wybrany Okres',
    '收益率': 'Stopa Zwrotu',
    '申请金额': 'Kwota Wniosku',
    '请输入申请金额': 'Proszę wprowadzić kwotę wniosku',
    '最大可申请金额': 'Maksymalna kwota do zastosowania',
    '投入限额': 'Limit Inwestycji',
    '最低投入': 'Minimalna Inwestycja',
    '最大投入': 'Maksymalna Inwestycja',
    '短投入限额': 'Limit',
    '请输入有效的申请金额': 'Proszę wprowadzić prawidłową kwotę wniosku',
    '申请金额不能低于最低投入': 'Kwota wniosku nie może być niższa niż minimalna inwestycja',
    '申请金额不能高于最大投入': 'Kwota wniosku nie może przekraczać maksymalnej inwestycji',

    // Error messages
    '网络错误，请稍后重试': 'Błąd sieci, spróbuj ponownie później',
    '参数错误': 'Błąd parametru',
    '服务器错误': 'Błąd serwera',
    '未知错误': 'Nieznany błąd',
    '请输入有效金额': 'Proszę wprowadzić prawidłową kwotę',
    '请输入大于0的解押金额': 'Proszę wprowadzić kwotę zwolnienia większą niż 0',
    '申请提交成功': 'Wniosek przesłany pomyślnie!',
    '您的解押申请已提交，请等待审核': 'Twój wniosek o zwolnienie został przesłany, czekaj na przegląd',
    '申请提交失败': 'Niepowodzenie przesłania wniosku',
    '请稍后重试': 'Spróbuj ponownie później',
    '您的账户余额不足，无法申请算力': 'Saldo Twojego konta jest niewystarczające do złożenia wniosku o moc obliczeniową',
    '您的算力申请已提交，请等待审核': 'Twój wniosek o moc obliczeniową został przesłany, czekaj na przegląd',
    '登录已过期': 'Sesja wygasła',
    '请重新连接钱包': 'Proszę ponownie połączyć portfel',
    '加载失败': 'Niepowodzenie ładowania',
    '无法获取解押申请记录': 'Nie można uzyskać rekordów wniosków o zwolnienie',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Masz wniosek oczekujący na przegląd, czekaj na zakończenie przeglądu przed przesłaniem nowego wniosku',
    '您还有未解押的算力订单，无法申请新的算力': 'Masz niewypłaconą zamówienie mocy obliczeniowej, nie możesz złożyć wniosku o nową moc obliczeniową',
    '申请次数已用完，最大申请次数': 'Osiągnięto limit wniosków, maksymalna liczba wniosków',
    '没有可解押的金额': 'Brak kwoty dostępnej do zwolnienia',
    '您已有待处理的解押申请，请等待审核': 'Masz już wniosek o zwolnienie oczekujący na przegląd',

    '我的算力订单': 'Moje Zamówienia Hashrate',
    '总质押': 'Łącznie w Stakingu',
    '总收益': 'Łączny Zysk',
    '进行中': 'Aktywne',
    '剩余天数': 'Pozostałe Dni',
    '暂无算力订单': 'Brak zamówień hashrate',

    // Okna popup związane z połączeniem portfela
    '钱包未连接': 'Portfel niepołączony',
    '钱包信息错误': 'Błąd informacji portfela',
    '钱包地址无效': 'Nieprawidłowy adres portfela',
    '授权已失效': 'Autoryzacja wygasła',
    '授权检查失败': 'Sprawdzenie autoryzacji nieudane',
    '请重新授权USDC后再进行投资': 'Proszę ponownie autoryzować USDC przed inwestowaniem',
    '请稍后重试或重新连接钱包': 'Spróbuj później lub ponownie połącz portfel',
    '断开连接': 'Rozłącz',
    '质押金额不足': 'Niewystarczająca kwota postawienia',
    '解押金额不能超过当前质押金额': 'Kwota zwolnienia nie może przekroczyć aktualnej kwoty postawienia',
    '需要连接钱包才能申请算力': 'Potrzeba połączyć portfel, aby złożyć wniosek o moc obliczeniową',
    '需要连接钱包才能申请解押': 'Potrzeba połączyć portfel, aby złożyć wniosek o zwolnienie',

    // Mapowanie tekstu statusu
    '状态待审核': 'Oczekujące',
    '状态成功': 'Sukces',
    '状态失败': 'Niepowodzenie',
    '状态进行中': 'W Trakcie',
    '状态已完成': 'Zakończone',
    '状态已取消': 'Anulowane',
    '状态未知': 'Nieznane',

    // Związane z adresem portfela
    '未连接钱包': 'Portfel nie połączony',
    '地址格式错误': 'Nieprawidłowy format adresu',

    // Obsługa klienta
    '客服功能开发中，敬请期待': 'Obsługa klienta jest w trakcie rozwoju, bądźcie czujni!',

    // Związane z ustawieniami mocy obliczeniowej
    '设置错误': 'Błąd ustawień',
    '未找到对应的算力设置': 'Nie znaleziono ustawień mocy obliczeniowej',
    '无法获取算力设置': 'Nie można uzyskać ustawień mocy obliczeniowej',

    // Związane z odblokowaniem (nowe)
    '解押审核中': 'Odblokowanie w Trakcie Przeglądu',
    '已解押': 'Odblokowane',
    '确认解押': 'Potwierdź Odblokowanie',
    '处理中': 'Przetwarzanie...',
    '解押申请已提交': 'Wniosek o Odblokowanie Złożony',
    '请等待审核处理': 'Proszę czekać na przegląd',
    '解押申请失败': 'Niepowodzenie Wniosku o Odblokowanie',
    '当前状态不允许解押': 'Bieżący status nie zezwala na odblokowanie',

    // Związane ze szczegółami zabezpieczenia (nowe)
    '质押明细': 'Szczegoly Hashrate',
    '后值': 'Wartość Po',
    '管理员操作': 'Operacja Systemu',
    '暂无质押记录': 'Brak rekordow hashrate',
    '正在加载质押记录': 'Ladowanie rekordow hashrate...',
    '获取质押记录失败': 'Nie udalo sie pobrac rekordow hashrate',
    '收益': 'Zyski',
    '质押': 'Hashrate',
    '解押': 'Wykup',
    '充值': 'Wpłata',
    '提现': 'Wypłata',
    '奖励': 'Nagroda',
    '推荐奖励': 'Nagroda za Polecenie',
    '系统调整': 'Dostosowanie Systemu',
    '算力收益': 'Zyski z Mocy Obliczeniowej',
    '机器人收益': 'Zyski z Bota',

    // Komunikaty ładowania i błędów (nowe)
    '无法获取申请详情': 'Nie można uzyskać szczegółów wniosku',
    '请检查网络连接后重试': 'Proszę sprawdzić połączenie sieciowe i spróbować ponownie',
    '未找到可解押的算力申请': 'Nie znaleziono wniosków o moc obliczeniową do odblokowania',

    // Związane ze statusem (nowe)

    // Związane ze stroną szczegółów (nowe)
    '算力申请详情': 'Szczegóły Wniosku o Moc Obliczeniową',
    '算力申请记录': 'Rekordy Wniosków o Moc Obliczeniową',
    '正在加载详情': 'Ładowanie szczegółów...',
    '申请周期': 'Okres Wniosku',
    '申请时间': 'Czas Wniosku',
    '累计收益': 'Łączne Zarobki',
    '暂无收益记录': 'Brak rekordów zarobków',
    '加载失败请重试': 'Niepowodzenie ładowania, proszę spróbować ponownie',
    '重新加载': 'Przeładuj',
    '包含累计收益': 'w tym łączne zarobki',
    '解押后资金将退回到平台资产中不再产生收益': 'Po odblokowaniu środki zostaną zwrócone do aktywów platformy i nie będą już generować zarobków.',
    '申请赎回': 'Wymień Hashrate',
    '赎回金额': 'Kwota Wymiany',
    '赎回审核中': 'Wymiana w Trakcie Weryfikacji',
    '未到期不可赎回': 'Nie można wymienić przed terminem',
    '暂不可赎回': 'Jeszcze Nie Można Wymienić',
    '当前算力未到期': 'Obecny hashrate nie wygasł, wymiana dostępna po terminie',
    '需要连接钱包才能申请赎回': 'Połącz portfel, aby złożyć wniosek o wymianę',
    '您的赎回申请已提交，请等待审核': 'Twój wniosek o wymianę został złożony, proszę czekać na weryfikację',
    '确认赎回': 'Potwierdź wymianę',
    '已赎回': 'Wymieniono',
    '您已有待处理的赎回申请，请等待审核': 'Masz już oczekujący wniosek o wymianę, proszę czekać',
    '当前状态不允许赎回': 'Obecny status nie pozwala na wymianę',
    '没有可赎回的金额': 'Brak dostępnej kwoty do wymiany'
  },

  // ==================== Strona Aktywów - Assets.vue ====================
  assets: {
    // Całkowite aktywa
    '总资产': 'Całkowite Aktywa',
    '复制成功': 'Skopiowano pomyślnie',

    // Przegląd dochodów
    '总收入': 'Całkowite Dochody',
    '今日收入': 'Dzisiejsze Dochody',
    '体验金': 'Saldo Demonstracyjne',
    '空投奖励': 'Nagrody Airdrop',

    // Przyciski akcji
    '充值': 'Wpłata',
    '快速充值说明': 'Szybko wplac USDC',
    '提现': 'Wypłata',
    '邀请': 'Zaproś',
    '白皮书': 'Biała Księga',
    '幸运轮': 'Koło Szczęścia',
    '站内信': 'Wiadomości',
    '信用分': 'Wynik Kredytowy',
    '快捷邀请': 'Zaproś',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Koło',
    '快捷信用分': 'Kredyt',

    // Poziom VIP
    'VIP等级': 'Poziom VIP',
    '暂无VIP等级数据': 'Brak danych o poziomie VIP',

    // Moje konto
    '我的账户': 'Moje Konto',
    '申请备用金': 'Złóż Wniosek o Fundusz Rezerwowy',
    '设置资金密码': 'Ustaw Hasło Funduszu',
    '选择语言': 'Wybierz Język',

    // Komunikaty logów konsoli
    '钱包未连接，触发钱包连接': 'Portfel nie połączony, uruchamianie połączenia portfela',
    '钱包地址无效，重新连接': 'Nieprawidłowy adres portfela, ponowne łączenie',
    '钱包已连接，直接跳转到充值页面': 'Portfel połączony, przekierowanie na stronę wpłat',
    '检查授权状态失败': 'Niepowodzenie sprawdzania statusu autoryzacji',
    '白皮书功能': 'Funkcja białej księgi',
    '检查资金密码状态失败': 'Niepowodzenie sprawdzania statusu hasła funduszu',

    // Logi związane z API
    'Token不存在，显示默认余额': 'Token nie istnieje, wyświetlanie domyślnego salda',
    '调用API获取用户余额数据': 'Wywołanie API w celu uzyskania danych salda użytkownika...',
    '体验金加载成功': 'Saldo demonstracyjne załadowane pomyślnie',
    '总资产计算完成': 'Obliczanie całkowitych aktywów zakończone',
    '余额': 'Saldo',
    '质押金额': 'Kwota Hashrate',
    'API返回失败': 'API zwróciło niepowodzenie',
    '加载用户余额失败': 'Niepowodzenie ładowania salda użytkownika',
    'Token不存在，显示默认收益': 'Token nie istnieje, wyświetlanie domyślnych zarobków',
    '调用API获取用户收益数据...': 'Wywołanie API w celu uzyskania danych zarobków użytkownika...',
    '收益数据加载成功': 'Dane zarobków załadowane pomyślnie',
    '收益API返回失败': 'API zarobków zwróciło niepowodzenie',
    '加载用户收益失败': 'Niepowodzenie ładowania zarobków użytkownika',
    '使用默认收益数据': 'Używanie domyślnych danych zarobków',
    '信用分加载成功': 'Wynik kredytowy załadowany pomyślnie'
  },

  // ==================== Strona Doładowania - Recharge.vue ====================
  recharge: {
    // Tytuł strony i nawigacja
    '充值': 'Doładowanie',
    '返回': 'Wstecz',
    '充值记录': 'Historia Doładowań',

    // Tytuły kroków
    '选择金额': 'Wybierz Kwotę',
    '确认订单': 'Potwierdź Zamówienie',
    '完成转账': 'Zakończ Transfer',

    // Wprowadzanie kwoty
    '请输入充值金额': 'Wprowadź kwotę doładowania',
    '自定义': 'Niestandardowy',
    '最小充值金额': 'Minimalna kwota doładowania',
    '最小充值金额提示': 'Minimum 500 USDC',
    '最大充值金额': 'Maksymalna kwota doładowania',
    '下一步': 'Dalej',
    '上一步': 'Wstecz',
    '开通自动转入': 'Włącz Automatyczny Transfer',

    // Informacje o zamówieniu
    '订单信息': 'Informacje o Zamówieniu',
    '订单号': 'Numer Zamówienia',
    '充值金额': 'Kwota Doładowania',
    '网络': 'Sieć',
    '代币': 'Token',
    '收款地址': 'Adres Odbiorczy',
    '创建订单': 'Utwórz Zamówienie',
    '创建中': 'Tworzenie...',

    // Połączenie portfela
    '请先连接钱包': 'Najpierw połącz portfel',
    '未检测到钱包地址，请先连接钱包': 'Adres portfela nie został wykryty, najpierw połącz portfel',

    // Saldo
    'USDC余额不足': 'Niewystarczające saldo USDC! Aktualne saldo',
    '转账超时，请检查钱包或重试': 'Timeout transferu, sprawdź portfel lub spróbuj ponownie',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Transfer zakończony sukcesem, ale nie otrzymano hash transakcji, podaj hash transakcji ręcznie',
    '请先连接MetaMask钱包': 'Najpierw połącz portfel MetaMask',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'Transfer mógł się powieść, ale nie można uzyskać hash transakcji, sprawdź portfel ręcznie',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Hash transakcji nieprawidłowy, skopiuj prawidłowy hash z historii portfela później',
    '钱包地址不存在': 'Adres portfela nie istnieje',
    '交易失败': 'Transakcja nie powiodła się',
    '当前网络': 'Aktualna sieć',
    '请切换到以太坊主网或测试网': 'Przełącz na sieć główną Ethereum lub testnet',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Kliknij ustawienia sieci w prawym górnym rogu strony, wybierz Ethereum, a następnie doładuj ponownie.',
    '需要': 'Wymagane',
    '更新订单失败': 'Aktualizacja zamówienia nie powiodła się',

    // Kroki transferu
    '请使用钱包转账': 'Użyj portfela do transferu',
    '转账地址': 'Adres Transferu',
    '转账金额': 'Kwota Transferu',
    '合约地址': 'Adres Kontraktu',
    '复制地址': 'Kopiuj Adres',
    '复制金额': 'Kopiuj Kwotę',
    '开始转账': 'Rozpocznij Transfer',
    '重新转账': 'Ponów Transfer',
    '查看详情': 'Zobacz Szczegóły',

    // Informacje o statusie
    '等待转账': 'Oczekiwanie na transfer',
    '转账中': 'Transfer w toku',
    '确认中': 'Potwierdzanie',
    '转账成功': 'Transfer udany',
    '转账失败': 'Transfer nieudany',
    '交易哈希': 'Hash Transakcji',
    '在区块链浏览器中查看': 'Zobacz w eksploratorze blockchain',

    // Wskazówki
    '请确保转账金额准确': 'Upewnij się, że kwota transferu jest dokładna',
    '请确保使用正确的网络': 'Upewnij się, że używasz właściwej sieci',
    '转账完成后系统会自动确认': 'System automatycznie potwierdzi po zakończeniu transferu',
    '地址已复制': 'Adres skopiowany',
    '金额已复制': 'Kwota skopiowana',
    '复制失败': 'Kopiowanie nieudane',

    // Komunikaty błędów
    '金额不能为空': 'Kwota nie może być pusta',
    '金额必须大于': 'Kwota musi być większa niż',
    '金额不能超过': 'Kwota nie może przekraczać',
    '创建订单失败': 'Tworzenie zamówienia nieudane',
    '转账失败，请重试': 'Transfer nieudany, spróbuj ponownie',
    '网络错误，请检查连接': 'Błąd sieci, sprawdź połączenie',

    // MetaMask相关
    '请安装MetaMask钱包': 'Proszę zainstalować portfel MetaMask',
    '网络检查通过': 'Sprawdzenie sieci zakończone sukcesem',
    'USDC余额不足！当前余额': 'Niewystarczające saldo USDC! Obecne saldo: {balance} USDC, wymagane: {amount} USDC',
    '余额检查通过': '✅ Sprawdzenie salda zakończone sukcesem',
    '余额检查失败': 'Sprawdzenie salda nie powiodło się',
    '开始执行转账': '🚀 Rozpoczynanie wykonania transferu...',
    '请在MetaMask中确认交易': '⏳ Proszę potwierdzić transakcję w MetaMask',
    '最终交易哈希': '✅ Końcowy hash transakcji',
    '交易哈希已保存到数据库': '✅ Hash transakcji zapisany w bazie danych',
    '保存哈希失败': '❌ Zapisywanie hash nie powiodło się',
    '转账发送失败': '❌ Wysyłanie transferu nie powiodło się',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Timeout przesyłania transakcji, sprawdź zapisy transakcji portfela lub spróbuj ponownie później',
    'Gas估算失败': 'Oszacowanie Gas nie powiodło się',
    '交易哈希更新成功': '✅ Hash transakcji zaktualizowany pomyślnie',
    '更新订单交易哈希失败': '❌ Aktualizacja hash transakcji zamówienia nie powiodła się',
    '启动交易监控，订单号': '🔄 Uruchamianie monitorowania transakcji, numer zamówienia',
    '检查交易状态': '🔍 Sprawdzanie statusu transakcji...',
    '订单状态响应': '📊 Odpowiedź statusu zamówienia',
    '订单详情': '📋 Szczegóły zamówienia',
    '交易成功': '✅ Transakcja udana!',
    '交易还在确认中，状态': '⏳ Transakcja nadal w potwierdzeniu, status',
    'API响应失败': '❌ Odpowiedź API nie powiodła się',
    '检查交易状态失败': 'Sprawdzenie statusu transakcji nie powiodło się',
    '转账状态已重置': '🔄 Status transferu zresetowany',

    // Obsługa klienta
    '客服功能开发中，敬请期待': 'Funkcja obsługi klienta w rozwoju, bądź na bieżąco!',

    // Poziomy stóp mocy obliczeniowej
    '查看算力收益等级': 'Zobacz poziomy stóp obliczeniowych',
    '算力收益等级': 'Poziomy stóp mocy obliczeniowej',
    '暂无算力收益等级数据': 'Brak danych o poziomach stóp obliczeniowych',
    '获取算力收益等级失败': 'Błąd podczas pobierania poziomów stóp obliczeniowych',
    '日收益率': 'Stopa dzienna'
  },

  // ==================== Strona Historii Doładowań - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Historia Doładowań',
    '全部': 'Wszystkie',
    '待支付': 'Oczekuje na Płatność',
    '待审核': 'Oczekuje na Przegląd',
    '确认中': 'Potwierdzanie',
    '成功': 'Sukces',
    '失败': 'Niepowodzenie',
    '已完成': 'Zakończone',
    '已取消': 'Anulowane',
    '暂无记录': 'Brak rekordów',
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',
    '没有更多数据': 'Brak więcej danych',
    '暂无充值记录': 'Brak rekordów doładowań',
    '立即充值': 'Doładuj Teraz',
    '充值': 'Doładowanie',
    '订单号': 'Numer Zamówienia',
    '筛选': 'Filtr',
    '记录': 'Rekordy',
    '总充值': 'Suma doladowan',
    '刚刚': 'Właśnie teraz',
    '分钟前': ' minut temu',
    '小时前': ' godzin temu'
  },

  // ==================== Strona Szczegółów Doładowania - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Szczegóły Doładowania'
  ,

    // 新增翻译键
    '加载中': 'Ładowanie',
    '订单不存在或已删除': 'Zamówienie nie istnieje lub zostało usunięte',
    '返回': 'Powrót',
    '订单信息': 'Informacje o zamówieniu',
    '订单号': 'Numer zamówienia',
    '充值网络': 'Sieć doładowania',
    '支付时间': 'Czas płatności',
    '确认时间': 'Czas potwierdzenia',
    '转账信息': 'Informacje o przelewie',
    '充值地址': 'Adres doładowania',
    '复制': 'Kopiuj',
    '交易哈希': 'Hash transakcji',
    '确认进度': 'Postęp potwierdzenia',
    '确认': 'Potwierdzenie',
    '查看区块浏览器': 'Zobacz eksplorator bloków',
    '取消订单': 'Anuluj zamówienie'
  },

  // ==================== Strona Wypłat - Withdrawal.vue ====================
  withdrawal: {
    // Tytuł strony i nawigacja
    '提现': 'Wypłata',
    '返回': 'Powrót',
    '提现记录': 'Historia Wypłat',

    // Wyświetlanie salda
    '我的提现账户余额': 'Saldo Mojego Konta Wypłat',
    '可提现余额': 'Dostępne Saldo',
    '当前可提取余额': 'Bieżące Dostępne Saldo',
    '信用分': 'Kredyt',

    // Pola formularza
    '提现金额': 'Kwota Wypłaty',
    '请输入提现金额': 'Proszę wprowadzić kwotę wypłaty',
    '请输入自定义提款金额': 'Proszę wprowadzić niestandardową kwotę',
    '最大限度': 'Maks',
    '提现地址': 'Adres Wypłaty',
    '请输入提现地址': 'Proszę wprowadzić adres wypłaty',
    '请输入正确的提现地址': 'Wprowadź prawidłowy adres wypłaty',
    '提现密码': 'Hasło Wypłaty',
    '请输入提现密码': 'Proszę wprowadzić hasło wypłaty',
    '资金密码': 'Hasło Środków',
    '请输入资金密码': 'Proszę wprowadzić hasło środków',
    '显示密码': 'Pokaż Hasło',
    '隐藏密码': 'Ukryj Hasło',

    // Zasady wypłat
    '提款规则': 'Zasady Wypłat',
    '提现规则': 'Zasady Wypłat',
    '手续费': 'Opłata',
    '单笔范围': 'Zakres na transakcję',
    '提现手续费': 'Opłata za Wypłatę',
    '提现金额范围': 'Zakres Kwoty Wypłaty',
    '资金将在1-24小时内到账': 'Środki dotrą w ciągu 1-24 godzin',
    '手续费率': 'Stawka Prowizji',
    '最小提现金额': 'Minimalna Wypłata',
    '最大提现金额': 'Maksymalna Wypłata',
    '预计到账时间': 'Oczekiwany Czas Dotarcia',
    '工作日内处理': 'Przetwarzane w dni robocze',

    // Przyciski i akcje
    '确认提款': 'Potwierdź Wypłatę',
    '处理中': 'Przetwarzanie',
    '提交申请': 'Złóż Wniosek',
    '设置资金密码': 'Ustaw Hasło Środków',
    '忘记密码？': 'Zapomniałeś Hasła?',
    '取消': 'Anuluj',
    '去设置': 'Przejdź do Ustawień',

    // Monity modalne
    '需要设置资金密码': 'Potrzeba Ustawić Hasło Środków',
    '为了您的资金安全，请先设置资金密码': 'Dla bezpieczeństwa Twoich środków, najpierw ustaw hasło środków',

    // Komunikaty sukcesu
    '申请提交成功': 'Wniosek Złożony Pomyślnie',
    '您的提现申请已提交，请等待审核': 'Twój wniosek o wypłatę został złożony, poczekaj na przegląd',
    '提现申请已提交': 'Wniosek o wypłatę złożony',
    '请等待审核': 'Poczekaj na przegląd',

    // Komunikaty błędów
    '申请提交失败': 'Złożenie Wniosku Nieudane',
    '提现申请失败': 'Wniosek o wypłatę nieudany',
    '请稍后重试': 'Spróbuj ponownie później',
    '余额不足': 'Niewystarczające Saldo',
    '金额格式错误': 'Nieprawidłowy format kwoty',
    '地址格式错误': 'Nieprawidłowy format adresu',
    '资金密码错误': 'Nieprawidłowe hasło środków',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Masz oczekujący wniosek o wypłatę, poczekaj na jego przetworzenie przed złożeniem nowego',
    '信用分不足': 'Niewystarczający Wynik Kredytowy',
    '信用分不足无法提款': 'Niewystarczający wynik kredytowy, nie można wypłacić',
    '您有待还款订单，请还款后申请提现': 'Masz niespłacone zamówienia pożyczkowe. Proszę spłacić przed złożeniem wniosku o wypłatę!',

    // Komunikaty systemowe i logi
    '用户提现申请': 'Wniosek o wypłatę użytkownika',
    '加载用户数据失败': 'Ładowanie danych użytkownika nieudane',
    '检查资金密码状态失败': 'Sprawdzenie statusu hasła środków nieudane'
  },



  // ==================== Modal Zaproszenia - InviteModal.vue ====================
  invite: {
    '邀请好友一起赚币': 'Zaproś przyjaciół do wspólnego zarabiania',
    '复制邀请码': 'Kopiuj kod zaproszenia',
    '朋友扫二维码注册加入': 'Przyjaciele skanują kod QR, aby się zarejestrować',
    '邀请链接': 'Link zaproszenia',
    '加载邀请数据失败': 'Błąd ładowania danych zaproszenia',
    '加载失败': 'Ładowanie nieudane',
    '获取邀请信息失败，请稍后重试': 'Błąd pobierania info zaproszenia, spróbuj później',
    '生成二维码失败': 'Błąd generowania kodu QR',
    '邀请码已复制': 'Kod zaproszenia skopiowany',
    '邀请链接已复制': 'Link zaproszenia skopiowany',
    '复制失败': 'Kopiowanie nieudane',
    '请手动复制': 'Skopiuj ręcznie'
  },

  // ==================== Strona Koło Fortuny - LuckyWheel.vue ====================
  luckyWheel: {
    '幸运轮': 'Koło Fortuny',
    '页面副标题': 'Losowanie siatkowe · podświetlenie',
    '剩余': 'Pozostałe',
    '次': 'razy',
    '奖金': 'Nagroda',
    '抽奖': 'Losuj',
    '奖品': 'Nagroda',
    '暂无中奖记录': 'Brak historii wygranych',
    '总抽奖次数': 'Laczna Liczba Losowan',
    '抽奖次数不足': 'Niewystarczające losowania',
    '提示': 'Powiadomienie',
    '抽奖失败': 'Losowanie nieudane',
    '网络错误': 'Błąd sieci',
    '网络错误，请重试': 'Błąd sieci, spróbuj ponownie',
    '中奖时间': 'Czas Wygranej',
    '中奖金额': 'Wygrana Kwota',
    '状态': 'Status',
    '暂无数据': 'Brak danych',
    '待发放': 'Oczekujące',
    '已发放': 'Wypłacone',
    '发放失败': 'Nieudane',
    '恭喜中奖': 'Gratulacje!',
    '确定': 'OK'
  },

  // ==================== Strona Wnioskuj o Fundusze - ApplyFunds.vue ====================
  applyFunds: {
    '申请备用金': 'Wnioskuj o Fundusze',
    '经平台审核，您可向平台申请一笔借款': 'Po przeglądzeniu platformy możesz wnioskować o pożyczkę',
    '借贷产品': 'Produkt Pożyczkowy',
    '请选择产品': 'Wybierz produkt',
    '借款金额': 'Kwota Pożyczki',
    '输入借款金额': 'Wprowadź kwotę pożyczki',
    '还款周期': 'Okres Spłaty',
    '请输入还款周期': 'Wprowadź okres spłaty',
    '天': 'dni',
    '日利率': 'Stawka Dzienna',
    '利息': 'Odsetki',
    '还款方式': 'Sposób Spłaty',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Darmowa usługa świadczona przez HamiltonLane, spłać z zewnętrznych funduszy',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Darmowa usługa świadczona przez HamiltonLane, spłać z zewnętrznych funduszy',
    '放款机构': 'Instytucja Pożyczkowa',
    '借款规则': 'Zasady Pożyczki',
    '下一步': 'Dalej',
    '姓名': 'Imię',
    '手机号': 'Telefon',
    '证件上传': 'Przesyłanie Dokumentów',
    '身份证正面': 'Przód Dowodu Osobistego',
    '身份证反面': 'Tył Dowodu Osobistego',
    '点击上传': 'Kliknij aby Przesłać',
    '重新上传': 'Prześlij Ponownie',
    '上传成功': 'Przesłano Pomyślnie',
    '上传失败': 'Błąd Przesyłania',
    '请上传身份证正面': 'Proszę przesłać przód dowodu osobistego',
    '请上传身份证反面': 'Proszę przesłać tył dowodu osobistego',
    '请输入': 'Wprowadź',
    '提交中': 'Wysyłanie...',
    '确定': 'Potwierdź',
    '请选择图片文件': 'Wybierz plik obrazu',
    '文件大小不能超过10MB': 'Rozmiar pliku nie moze przekraczac 10MB',
    '恭喜您申请成功': 'Gratulacje udanego wniosku',
    '您的借款已申请成功，待平台审核成功放款': 'Twój wniosek o pożyczkę został złożony pomyślnie, oczekuje na zatwierdzenie platformy',
    '选择借贷产品': 'Wybierz Produkt Pożyczkowy',

    // Komunikaty błędów
    '申请失败': 'Wniosek Nieudany',
    '申请失败，请重试': 'Wniosek nieudany, spróbuj ponownie',

    // Tłumaczenia nazw produktów
    '产品名称': {
      '快速借贷': 'Szybka Pożyczka',
      '标准借贷': 'Standardowa Pożyczka',
      '长期借贷': 'Pożyczka Długoterminowa',
      '小额借贷': 'Mikropożyczka',
      '大额借贷': 'Pożyczka na Dużą Kwotę',
      '短期借贷产品': 'Produkt Pożyczki Krótkoterminowej'
    },

    // Tłumaczenia opisów produktów
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Odpowiedni do krótkoterminowego obrotu kapitałem, preferencyjne stopy procentowe, szybka akceptacja'
    },

    // Tłumaczenia komunikatów API
    'API消息': {
      '获取借贷产品成功': 'Produkty pożyczkowe pobrane pomyślnie'
    }
  },

  // ==================== Strona Rekordy Pożyczek - LoanRecords.vue ====================
  loanRecords: {
    '借款记录': 'Rekordy Pożyczek',
    '借贷中心': 'Centrum Pozyczek',
    '总记录': 'Liczba Rekordow',
    '总借款': 'Laczna Pozyczka',
    '进行中': 'W trakcie',
    '全部': 'Wszystkie',
    '加载中': 'Ładowanie',
    '没有更多数据了': 'Brak więcej danych',
    '借款': 'Pożyczka',
    '借款金额': 'Kwota Pożyczki',
    '还款周期': 'Okres Spłaty',
    '天': 'dni',
    '日利率': 'Stawka Dzienna',
    '利息': 'Odsetki',
    '还款方式': 'Sposób Spłaty',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Darmowa usługa świadczona przez HamiltonLane, spłać z zewnętrznych funduszy',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Darmowa usługa świadczona przez HamiltonLane, spłać z zewnętrznych funduszy',
    '放款机构': 'Instytucja Pożyczkowa',
    '待审核': 'Oczekujące',
    '已通过': 'Zatwierdzone',
    '审核成功': 'Zatwierdzone',
    '已驳回': 'Odrzucone',
    '审核失败': 'Odrzucone',
    '已还款': 'Spłacone',
    '已逾期': 'Przeterminowane',
    '逾期': 'Przeterminowane',
    '未知状态': 'Nieznany Status'
  },

  // ==================== Strona Ustaw Hasło Funduszy - SetFundPassword.vue ====================
  setFundPassword: {
    '设置资金密码': 'Ustaw Hasło Funduszy',
    '安全中心': 'Centrum Bezpieczenstwa',
    '密码长度至少6位': 'Hasło musi mieć co najmniej 6 znaków',
    '密码长度不超过20位': 'Hasło nie może przekraczać 20 znaków',
    '确认密码': 'Potwierdź Hasło',
    '两次输入的密码一致': 'Hasła się zgadzają',
    '设置中': 'Ustawianie...',
    '确定': 'Potwierdź',

    // Komunikaty odpowiedzi API
    '参数验证失败': 'Walidacja parametrów nie powiodła się',
    '您已设置过资金密码，如需修改请联系客服': 'Już ustawiłeś hasło funduszy. Skontaktuj się z obsługą klienta, aby je zmodyfikować',
    '资金密码设置成功': 'Hasło funduszy zostało pomyślnie ustawione',
    '设置失败': 'Ustawienie nie powiodło się',
    '获取状态失败': 'Nie udało się pobrać statusu',

    // Komunikaty zachęty frontend
    '设置成功': 'Ustawiono pomyślnie',
    '请稍后重试': 'Spróbuj ponownie później',
    '设置资金密码失败': 'Nie udało się ustawić hasła funduszy'
  },

  // ==================== Strona Modyfikuj Hasło Funduszy - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Tytuł strony
    '修改资金密码': 'Modyfikuj Hasło Funduszy',
    '修改安全密码': 'Modyfikuj Hasło Bezpieczeństwa',
    '返回': 'Powrót',

    // Wyświetlanie statusu
    '已设置资金密码': 'Hasło funduszy zostało ustawione',

    // Pola formularza
    '原密码': 'Aktualne Hasło',
    '请输入原密码': 'Wprowadź aktualne hasło',
    '新密码': 'Nowe Hasło',
    '请输入新密码': 'Wprowadź nowe hasło',
    '确认新密码': 'Potwierdź Nowe Hasło',
    '请再次输入新密码': 'Wprowadź ponownie nowe hasło',

    // Przyciski i akcje
    '确认修改': 'Potwierdź Modyfikację',
    '修改中': 'Modyfikowanie...',
    '忘记原密码': 'Zapomniałeś aktualne hasło?',
    '忘记安全密码': 'Zapomniałeś hasło bezpieczeństwa?',
    '联系客服': 'Skontaktuj się z Pomocą',
    '取消': 'Anuluj',

    // Wskazówki
    '原密码不能为空': 'Aktualne hasło nie może być puste',
    '原密码错误': 'Aktualne hasło jest nieprawidłowe',
    '新密码不能与原密码相同': 'Nowe hasło nie może być takie samo jak aktualne',
    '密码修改成功': 'Hasło zostało pomyślnie zmodyfikowane',
    '密码修改失败': 'Modyfikacja hasła nie powiodła się',
    '如需重置安全密码，请联系客服人员协助处理': 'Aby zresetować hasło bezpieczeństwa, skontaktuj się z obsługą klienta w celu uzyskania pomocy',

    // Komunikaty odpowiedzi API
    '参数验证失败': 'Walidacja parametrów nie powiodła się',
    '您尚未设置资金密码': 'Nie ustawiłeś jeszcze hasła funduszy',
    '资金密码修改成功': 'Hasło funduszy zostało pomyślnie zmodyfikowane',
    '修改失败': 'Modyfikacja nie powiodła się',

    // Komunikaty zachęty frontend
    '修改安全密码失败': 'Nie udało się zmodyfikować hasła bezpieczeństwa',
    '请稍后重试': 'Spróbuj ponownie później'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Długość hasła 6-20 znaków',
    '两次输入的密码一致': 'Hasła są zgodne'
  },

  // ==================== Strona Inwestycji Robot - RobotInvestment.vue ====================
  robotInvestment: {
    // Tytuł strony
    '详情': 'Szczegóły',
    '返回': 'Powrót',

    // Informacje o zakupie
    '申购金额': 'Kwota zakupu',
    '购买金额': 'Kwota zakupu',
    '最大': 'Maks',
    '最小限额': 'Limit minimalny',
    '最大限额': 'Limit maksymalny',
    '日收益率': 'Dzienna stopa zwrotu',
    '周期': 'Okres',
    '天': 'Dni',

    // Informacje o saldzie
    '可用余额': 'Dostępne saldo',
    '可购次数': 'Liczba zakupów',

    // Przyciski i status
    '处理中': 'Przetwarzanie',
    '申购': 'Kup',
    '余额错误': 'Blad salda',
    '无法获取有效的余额信息': 'Nie mozna pobrac poprawnego salda',
    '输入错误': 'Blad danych',
    '请输入申购金额': 'Wprowadz kwote zakupu',
    '请输入有效的申购金额': 'Wprowadz poprawna kwote zakupu',
    '钱包未连接': 'Portfel niepolaczony',
    '请先连接钱包': 'Najpierw polacz portfel',
    '钱包信息错误': 'Blad danych portfela',
    '请重新连接钱包': 'Polacz portfel ponownie',
    '钱包地址无效': 'Nieprawidlowy adres portfela',
    '授权已失效': 'Autoryzacja wygasla',
    '请重新授权USDC后再进行投资': 'Ponownie autoryzuj USDC przed inwestycja',
    '授权检查失败': 'Nieudane sprawdzenie autoryzacji',
    '请稍后重试或重新连接钱包': 'Sprobuj pozniej lub polacz portfel ponownie',
    '金额不足': 'Kwota za mala',
    '申购金额不能少于': 'Kwota zakupu nie moze byc mniejsza niz',
    '金额超限': 'Przekroczono limit',
    '申购金额不能超过': 'Kwota zakupu nie moze przekroczyc',
    '余额不足': 'Niewystarczajace saldo',
    '您的可用余额为': 'Dostepne saldo to',
    '无法完成此次申购': 'nie mozna zrealizowac tego zakupu',
    '申购成功': 'Zakup udany',
    '订单号': 'Numer zamowienia',
    '申购失败': 'Zakup nieudany',
    '申购失败，请稍后重试': 'Zakup nieudany, sprobuj ponownie pozniej',
    '网络错误，请稍后重试': 'Blad sieci, sprobuj ponownie pozniej'
  },

  // ==================== Opcje Flash - FlashOptions.vue ====================
  flashOptions: {
    '闪电期权': 'Opcje Flash',
    '请先连接钱包': 'Proszę połączyć portfel',
    '连接钱包后即可开始闪电期权交易': 'Połącz portfel, aby rozpocząć handel opcjami flash',
    '连接钱包': 'Połącz portfel',
    '加载中': 'Ładowanie...',
    '暂无可交易资产': 'Brak aktywów do handlu',
    '请稍后再试': 'Spróbuj ponownie później',
    '时间': 'Czas',
    '金额': 'Kwota',
    '回报额': 'Zwrot',
    '利润': 'Zysk',
    '当前持仓': 'Otwarte pozycje',
    '暂无持仓': 'Brak pozycji',
    '买涨': '▲ W górę',
    '买跌': '▼ W dół',
    '开仓': 'Otwarcie',
    '入场价': 'Cena wejścia',
    '出场价': 'Cena wyjścia',
    '收益率': 'Zwrot',
    '投入': 'Kwota',
    '入场时间': 'Czas wejścia',
    '出场时间': 'Czas wyjścia',
    '实时价': 'Cena na żywo',
    '倒计时': 'Odliczanie',
    '交易记录': 'Historia',
    '暂无记录': 'Brak rekordów',
    '涨': 'Wzrost',
    '跌': 'Spadek',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Rozliczanie...',
    '加载配置失败': 'Nie udało się załadować',
    '请完善交易信息': 'Uzupełnij informacje',
    '下单失败': 'Zamówienie nie powiodło się',
    '买涨成功': 'Zakup w górę udany',
    '买跌成功': 'Zakup w dół udany',
    '等待行情数据': 'Oczekiwanie na dane rynkowe...',
    '余额不足': 'Niewystarczające saldo',
    '资产不可用': 'Zasób niedostępny',
    '周期不可用': 'Okres niedostępny',
    '智能交易': 'Handel AI',
    '交易标的': 'Aktywo',
    '风险类型': 'Typ ryzyka',
    '投入金额': 'Kwota',
    '提交申请': 'Wyślij',
    '我的AI订单': 'Moje zlecenia AI',
    '稳健型': 'Konserwatywny',
    '平衡型': 'Zrównoważony',
    '进取型': 'Agresywny',
    '稳健': 'Bezpieczny',
    '平衡': 'Zrównoważony',
    '进取': 'Agresywny',
    '低风险低回报适合稳健投资者': 'Niskie ryzyko, niski zwrot. Dla konserwatywnych inwestorów.',
    '中等风险中等回报适合大多数投资者': 'Średnie ryzyko, średni zwrot. Dla większości inwestorów.',
    '高风险高回报适合激进投资者': 'Wysokie ryzyko, wysoki zwrot. Dla agresywnych inwestorów.',
    '待审核': 'Oczekujące',
    '运行中': 'Działa',
    '已停止': 'Zatrzymane',
    '已结算': 'Rozliczone',
    '已驳回': 'Odrzucone',
    'AI剩余': 'Pozostało',
    'AI做单': 'Transakcje',
    'AI笔': '',
    'AI胜': 'W',
    'AI负': 'P',
    '请先选择交易标的': 'Najpierw wybierz aktywo',
    '请输入有效金额': 'Wprowadź prawidłową kwotę',
    'AI交易申请已提交': 'Zlecenie AI złożone, oczekuje na weryfikację',
    'AI提交失败': 'Nie udało się wysłać',
    '停止交易': 'Zatrzymaj',
    '确认停止AI交易': 'Zatrzymać handel AI? Pozostałe środki zostaną zwrócone.',
    '停止失败': 'Nie udało się zatrzymać',
    '确认取消AI申请': 'Anulować wniosek AI? Zamrożone środki zostaną zwrócone.',
    '取消失败': 'Nie udało się anulować',
    '体验金': 'Demo',
    '体验金不足': 'Niewystarczające saldo demo',
    '可用余额': 'Dost.',
    '累计盈亏': 'PnL',
  },

  // ==================== Dolna Nawigacja - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Start',
    '投资': 'Inwestuj',
    '闪期权': 'Flash',
    '算力申请': 'Wealth',
    '资产': 'Profil'
  },

  // ==================== Dzienniki Zmian Salda - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Dzienniki Zmian Salda',
    '总收入': 'Całkowity Dochód',
    '总支出': 'Całkowite Wydatki',
    '净收益': 'Zysk Netto',
    '记录总数': 'Łączna Liczba Rekordów',
    '资产中心': 'Centrum Aktywów',
    '筛选': 'Filtr',
    '更多类型': 'Więcej Typów',
    '金额方向': 'Kierunek Kwoty',
    '流入': 'Wpływ',
    '流出': 'Wypływ',
    '关键词': 'Słowo Kluczowe',
    '搜索类型原因备注': 'Szukaj typu/powodu/uwagi',
    '重置': 'Resetuj',
    '完成': 'Gotowe',
    '当前筛选': 'Aktualny Filtr',
    '记录条数': 'Liczba Rekordów',
    '净额': 'Saldo Netto',
    '点击查看详情': 'Dotknij, aby zobaczyć szczegóły',
    '账变记录页面已加载': 'Strona dzienników zmian salda załadowana',
    '全部': 'Wszystko',
    '用户充值': 'Doładowanie Użytkownika',
    '管理操作': 'Operacja Systemu',
    '用户提现': 'Wypłata Użytkownika',
    '借贷': 'Pozyczka',
    '借贷到账': 'Pozyczka Zaksiegowana',
    '算力申请': 'Wniosek o Moc Obliczeniową',
    '机器人收益': 'Zyski z Robota',
    '算力收益': 'Zyski z Mocy Obliczeniowej',
    '空投': 'Airdrop',
    '幸运轮': 'Koło Fortuny',
    '闪期权': 'Opcje Flash',
    '加载中': 'Ładowanie',
    '暂无记录': 'Brak Rekordów',
    '暂无账变记录': 'Brak rekordów zmian salda',
    '余额变化': 'Zmiana Salda',
    '加载更多': 'Załaduj Więcej',
    '记录详情': 'Szczegóły Rekordu',
    '业务类型': 'Typ Biznesu',
    '操作类型': 'Typ Operacji',
    '变动金额': 'Kwota Zmiany',
    '变动前余额': 'Saldo Przed Zmianą',
    '变动后余额': 'Saldo Po Zmianie',
    '变动原因': 'Powód Zmiany',
    '备注': 'Uwagi',
    '状态': 'Status',
    '交易哈希': 'Hash Transakcji',
    '创建时间': 'Czas Utworzenia',
    '处理时间': 'Czas Przetwarzania',
    '刚刚': 'Właśnie teraz',
    '分钟前': 'minut temu',
    '小时前': 'godzin temu',
    '关闭': 'Zamknij',
    '没有更多记录': 'Brak Więcej Rekordów',
    'Balance Change': 'Zmiana Salda',
    'User Recharge': 'Doładowanie Użytkownika',
    'User Withdrawal': 'Wypłata Użytkownika',
    'Computing Earnings': 'Zyski z Mocy Obliczeniowej',
    'Robot Earnings': 'Zyski z Robota',
    'Completed': 'Zakończone',
    'Processing': 'Przetwarzanie',
    'System Operation': 'Operacja Systemu',
    'Recharge': 'Doładowanie',
    'Withdrawal': 'Wypłata',
    'Reward': 'Nagroda',
    'Referral Reward': 'Nagroda Polecenia',
    'Lucky Wheel': 'Koło Fortuny',
    'Airdrop': 'Airdrop',
    'Add': 'Dodaj',
    'Subtract': 'Odejmij',
    'Set': 'Ustaw',
    'Pending': 'Oczekujące',
    'Pending Review': 'Oczekujące na Przegląd',
    'Failed': 'Nieudane',
    'Cancelled': 'Anulowane',
    'Unknown': 'Nieznane',
    'Success': 'Sukces',
    'In Progress': 'W Toku',

    // Typy Biznesu (niektóre klucze istnieją gdzie indziej, skomentowane aby uniknąć duplikatów)
    // '充值': 'Doładowanie',
    // '提现': 'Wypłata',
    // '算力申请': 'Moc Obliczeniowa', // Zduplikowany klucz, już zdefiniowany gdzie indziej
    'AI机器人': 'Robot AI',
    '解押': 'Wykup',
    '管理员操作': 'Operacja Systemu',
    '推荐佣金': 'Prowizja Polecająca',
    // '奖励': 'Nagroda',
    '幸运轮盘': 'Koło Fortuny',
    '其他': 'Inne',

    // Statusy
    '待审核': 'Oczekujące na Przegląd',
    '处理中': 'W Trakcie Przetwarzania',
    '待处理': 'Oczekujące',
    '已完成': 'Zakończone',
    '失败': 'Nieudane',
    '已取消': 'Anulowane',

    // Typy Akcji
    '增加': 'Dodaj',
    '减少': 'Odejmij',
    '设置': 'Ustaw',

    // Typy Kont
    '余额变动': 'Zmiana Salda',
    '质押变动': 'Zmiana Stake',

    // Tłumaczenia Powodu
    'reason_recharge_arrived': 'Doładowanie Przybyło',
    'reason_withdrawal_apply': 'Wniosek o Wypłatę, Saldo Zamrożone',
    'reason_withdrawal_rejected': 'Wniosek o Wypłatę Odrzucony, Zamrożone Saldo Zwrócone',
    'reason_withdrawal_success': 'Wypłata Pomyślna',
    'reason_computing_apply': 'Wniosek o Moc Obliczeniową, Saldo Zamrożone',
    'reason_unstake_success': 'Odblokowanie Pomyślne, Stake Rozmrożony do Salda',
    'reason_computing_earning': 'Zyski z Mocy Obliczeniowej Przybyły',
    'reason_computing_unstake': 'Odblokowanie Mocy Obliczeniowej Wygasło',
    'reason_robot_invest': 'Inwestycja w Robota AI',
    'reason_robot_earning': 'Zyski z Robota Przybyły',
    'reason_loan_credit': 'Zatwierdzona pozyczka zaksiegowana',
    'reason_unstake_approved': 'Wniosek o Odblokowanie Zatwierdzony',
    'reason_referral_commission': 'Prowizja Polecająca Przybyła',
    'reason_lucky_wheel_reward': 'Nagroda Koła Fortuny',
    'reason_airdrop': 'Nagroda Airdrop',
    'reason_reward': 'Dystrybucja Nagrody',
    'reason_airdrop_issue': 'Dystrybucja Airdrop',
    'reason_flash_option_buy': 'Zlecenie Opcji Flash',
    'reason_flash_option_win': 'Zysk z Opcji Flash',
    'reason_flash_option_draw': 'Zwrot Remisu Opcji Flash',
    'reason_flash_option_lose': 'Strata Opcji Flash',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Tłumaczenia Uwagi
    'remark_recharge_order': 'Zamówienie Doładowania',
    'remark_withdrawal_order': 'Zamówienie Wypłaty',
    'remark_application_rejected': 'Wniosek Odrzucony',
    'remark_transaction_hash': 'Hash Transakcji',
    'remark_computing_application': 'Wniosek Obliczeniowy',
    'remark_unstake_application': 'Wniosek o Odblokowanie',
    'remark_robot_order': 'Zamówienie Robota',
    'remark_lucky_wheel_reward': 'Nagroda Koła Fortuny',
    'remark_robot_earning': 'Zyski z Robota',
    'remark_computing_earning': 'Zyski z Mocy Obliczeniowej',
    'remark_computing_earning_to_stake': 'Zyski z Mocy Obliczeniowej Dodane do Stake',
    'remark_flash_option_buy': 'Zlecenie Opcji Flash',
    'remark_flash_option_win': 'Zysk z Opcji Flash',
    'remark_flash_option_draw': 'Zwrot Remisu Opcji Flash',
    'remark_flash_option_lose': 'Strata Opcji Flash',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Dystrybucja Airdrop',

    '闪期权下单': 'Zlecenie Opcji Flash',
    '闪期权盈利': 'Zysk z Opcji Flash',
    '闪期权平局': 'Remis Opcji Flash',
    '闪期权亏损': 'Strata Opcji Flash',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Dystrybucja Airdrop',
    '算力收益发放': 'Dystrybucja Dochodów z Obliczeń',
    '奖励发放': 'Dystrybucja Nagród',
    '成功': 'Sukces'
  },

  // ==================== Strona Główna - Home.vue ====================
  home: {
    // Główna Treść
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet polaczony',
    'walletNotConnected': 'Wallet niepolaczony',
    'heroMarketTag': 'Private Markets',

    // Sekcja Inwestycji
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Treść Kategorii
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Wspólne
    'more': 'Więcej',
    'collapse': 'Zwiń',

    // Sekcja Zarobków
    'earningsTitle': 'Performance',

    // Wprowadzenie Firmy
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane to globalne przedsiębiorstwo wysokich technologii z siedzibą w Singapurze, utworzone wspólnie przez Bitmain, A*STAR Institute of High Performance Computing (IHPC) i Core Scientific, Inc...',
    'companyFull': 'HamiltonLane to globalne przedsiębiorstwo wysokich technologii z siedzibą w Singapurze, utworzone wspólnie przez Bitmain, A*STAR Institute of High Performance Computing (IHPC) i Core Scientific, Inc. Firma koncentruje się na głębokiej integracji sztucznej inteligencji (AI) i technologii blockchain, zobowiązując się do budowania wiodących na świecie systemów mocy obliczeniowej kryptowalut i infrastruktury ekosystemu inteligentnej mocy obliczeniowej, napędzając zrównoważony rozwój nowej generacji inteligentnej gospodarki. Jako innowacyjne przedsiębiorstwo utworzone wspólnie przez trzy instytucje o globalnym wpływie w swoich dziedzinach, HamiltonLane łączy centralne zalety technologiczne Bitmain w projektowaniu chipów blockchain i sprzęcie mocy obliczeniowej, międzynarodową siłę badawczą IHPC w obliczeniach wysokiej wydajności i optymalizacji algorytmów AI, oraz wiodące doświadczenie Core Scientific w budowie infrastruktury blockchain i eksploatacji centrów danych. Synergiczna współpraca trzech stron umożliwia HamiltonLane posiadanie potężnych możliwości integracji technologicznej i alokacji zasobów globalnych, ustanawiając solidną podstawę dla wydajnego, bezpiecznego i inteligentnego rozwoju sieci mocy obliczeniowej. Niezależnie opracowany przez HamiltonLane zdecentralizowany system inteligentnej mocy obliczeniowej (Decentralized Intelligent Computing Network, DICN) integruje planowanie mocy obliczeniowej AI, inteligentne kontrakty blockchain i technologię obliczeń wysokiej wydajności, realizując zautomatyzowane zarządzanie i optymalizację przychodów zasobów mocy obliczeniowej. System może realizować alokację mocy obliczeniowej między sieciami, monitorowanie w czasie rzeczywistym i optymalizację efektywności energetycznej w ekosystemach wielołańcuchowych, znacznie poprawiając wykorzystanie mocy obliczeniowej i ogólną efektywność przychodów. Jednocześnie, poprzez głębokie uczenie i modele predykcyjne algorytmów AI, system może realizować automatyczną identyfikację ryzyka, analizę trendów rynkowych i dynamiczne planowanie zasobów, zapewniając globalnym użytkownikom przejrzyste, bezpieczne i inteligentne doświadczenia usług mocy obliczeniowej. System biznesowy HamiltonLane obejmuje budowę sieci mocy obliczeniowej AI, zarządzanie mocą obliczeniową blockchain, obliczenia wysokiej wydajności w chmurze, szyfrowanie danych i ochronę prywatności oraz systemy inwestycji przychodów on-chain. Firma aktywnie promuje zastosowanie mocy obliczeniowej sztucznej inteligencji w branżach zdecentralizowanych finansów (DeFi), Web3.0, obliczeń w chmurze i obliczeń badawczych, budując kompleksowe rozwiązania mocy obliczeniowej od sprzętu bazowego do ekosystemów wyższego poziomu. Przestrzegając filozofii rozwoju "Intelligence Empowers the Future", HamiltonLane przyjmuje innowacje technologiczne jako centralną siłę napędową oraz zgodność, bezpieczeństwo i przejrzystość jako zasady operacyjne, zobowiązując się do zapewnienia globalnym instytucjom i inwestorom indywidualnym zintegrowanych rozwiązań zarządzania aktywami mocy obliczeniowej i inwestycji napędzanych przez AI. Poprzez wspólną współpracę technologiczną i przemysłową Bitmain, IHPC i Core Scientific, HamiltonLane przyspiesza budowę globalnej sieci infrastruktury inteligentnej mocy obliczeniowej, stając się ważnym mostem łączącym sztuczną inteligencję i gospodarkę blockchain, zapewniając solidne wsparcie mocy obliczeniowej i strategiczną siłę napędową dla globalnych procesów cyfryzacji i inteligentyzacji.',
    'persistentLink': 'Dowiedz Się Więcej o Persistent Systems',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Często Zadawane Pytania',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Platformy Partnerskie
    'partnerTitle': 'Partners',

    // Obsługa Klienta
    'customerServiceDevelopment': 'Obsługa klienta jest w trakcie rozwoju, bądźcie czujni!'
  },

  // ==================== Strona Zasady Pożyczek - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Zasady Pożyczek',
    '人工智能算力贷款协议说明': 'Opis Umowy Pożyczki Mocy Obliczeniowej AI',
    '协议前言': 'W związku z dobrą historią transakcji Strony A, Strona B zgadza się podpisać tę "Umowę Pożyczki Mocy Obliczeniowej AI" ze Stroną A na podstawie dobrowolności, równości i wzajemnej zgody. Obie strony powinny uważnie przeczytać tę umowę, wyjaśnić swoje odpowiednie prawa i obowiązki oraz współpracować w promowaniu i standaryzacji działań zarobkowych związanych z mocą obliczeniową AI.',
    '贷款金额及抵押物要求': '1. Kwota Pożyczki i Wymagania Zabezpieczenia',
    '贷款额度说明': 'Strona B zapewni limit pożyczki od 5 000 do 50 000 USDC na podstawie zapisów transakcji i statusu kredytowego Strony A na koncie crypto.com. Ten limit może być wielokrotnie wnioskowany, a ostateczna zatwierdzona kwota będzie podlegać wynikom oceny systemu platformy.',
    '贷款期限': 'Okres Pożyczki',
    '期限说明': 'Okres pożyczki w ramach tej umowy wynosi 7 dni, 15 dni lub 30 dni, który będzie niezależnie wybrany i określony przez Stronę B przed pożyczką na podstawie wniosku i wyników oceny platformy, i potwierdzony w momencie pożyczki.',
    '资金要求': 'Strona A musi zapewnić, że fundusze i dostępne aktywa krypto na jej koncie są wystarczające do spełnienia wymagań zatwierdzenia pożyczki i kontroli ryzyka.',
    '审批流程': 'Przed wypłatą funduszy, Strona A musi ukończyć proces zatwierdzania pożyczki sformułowany przez Stronę B, w tym między innymi ocenę statusu kredytowego i przegląd przepływu funduszy.',
    '资金使用': '2. Użycie Funduszy',
    '使用限制': 'Fundusze pożyczki wypłacone przez Stronę B są ograniczone do inwestycji w moc obliczeniową agenta AI i nie mogą być używane do innych celów.',
    '使用规定': 'Strona A musi ściśle przestrzegać odpowiednich regulacji dotyczących użycia funduszy pożyczki i powinna dostarczyć instrukcje użycia funduszy Stronie B zgodnie z wymaganiami w rozsądnym okresie po otrzymaniu funduszy, aby zapewnić zgodność użycia funduszy.',
    '借款与还款说明': '3. Instrukcje Pożyczki i Spłaty',
    '借款还款规定': 'Fundusze pożyczki są ściśle ograniczone do uczestnictwa w Puli Super Obliczeń HamiltonLane i nie mogą być używane do innych celów. Okres pożyczki będzie zgodny z pozostałym cyklem operacyjnym Puli Super Obliczeń, w której uczestniczy użytkownik (Strona A). Wszystkie pożyczki muszą być w pełni spłacone w ciągu 24 godzin przed końcem cyklu puli obliczeniowej. Niepowodzenie w spłacie na czas spowoduje opłaty za opóźnienie i kary zgodnie z odpowiednimi warunkami. Pożyczkobiorca (Strona A) musi rozsądnie zorganizować swój plan finansowy, aby zapewnić terminowe wykonanie.',
    '借款须知': '4. Powiadomienie o Pożyczce',
    '身份验证要求': 'Wszystkie wnioski o pożyczkę muszą przesłać i przesłać ważne dokumenty tożsamości oraz informacje o obszarze mieszkalnym. Ma to na celu ukończenie weryfikacji tożsamości i przeglądu zgodności, aby zapewnić, że proces pożyczki jest bezpieczny, przejrzysty i spełnia wymagania regulacyjne. System będzie przechowywać i przeglądać informacje użytkownika pod ścisłymi mechanizmami szyfrowania danych i ochrony prywatności, które będą używane tylko do oceny kwalifikacji pożyczki i zarządzania ryzykiem, i nie będą używane do żadnych innych celów. Wnioskodawcy muszą zapewnić, że podane informacje są prawdziwe i dokładne, aby uniknąć wpływu na przegląd pożyczki i postęp wypłaty funduszy.'
  },

  // ==================== Górny Nagłówek - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Wybierz Sieć',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Logowanie w toku',
    '连接钱包': 'Połącz Portfel',
    '连接中': 'Łączenie...',
    '已连接': 'Połączony',
    '连接成功': 'Połączenie Pomyślne!',
    '钱包已成功连接': 'Portfel połączony pomyślnie',
    '钱包信息': 'Informacje o Portfelu',
    '钱包地址': 'Adres Portfela',
    '断开连接': 'Rozłącz',
    '已断开连接': 'Rozłączony',
    '正在初始化': 'Inicjalizacja...',
    '正在切换网络': 'Przełączanie sieci...',
    '登录完成': 'Logowanie zakończone',
    '请在钱包中确认': 'Proszę potwierdzić w portfelu...',
    '登录成功': 'Logowanie pomyślne',

    // Komunikaty błędów połączenia portfela
    '钱包连接失败': 'Połączenie portfela nie powiodło się',
    '未知错误': 'Nieznany błąd',
    '认证失败，请重试连接钱包': 'Uwierzytelnienie nie powiodło się, proszę spróbować ponownie połączyć portfel',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Żądanie połączenia portfela jest przetwarzane, proszę poczekać lub odświeżyć stronę i spróbować ponownie',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Żądanie połączenia portfela oczekuje, proszę potwierdzić w swoim portfelu',
    '授权失败': 'Autoryzacja nie powiodła się',
    '交易被撤销，可能是合约错误或余额不足': 'Transakcja została cofnięta, prawdopodobnie z powodu błędu kontraktu lub niewystarczającego salda',

    // Komunikaty statusu połączenia portfela
    '欢迎！您的账户已创建成功': 'Witamy! Twoje konto zostało pomyślnie utworzone',
    '钱包连接成功': 'Portfel połączony pomyślnie',
    '钱包已断开连接': 'Portfel rozłączony',
    '是否断开钱包连接？': 'Rozłączyć portfel?',

    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Portfel nie jest połączony, proszę najpierw połączyć portfel',
    '中文（简体）': 'Chiński (Uproszczony)',
    '用户取消了授权': 'Użytkownik anulował autoryzację',
    'ETH余额不足，无法支付Gas费用': 'Niewystarczające saldo ETH, nie można zapłacić opłat za gaz',
    'Gas费用设置过低': 'Opłaty za gaz ustawione zbyt nisko',
    '交易nonce错误，请重试': 'Błąd nonce transakcji, proszę spróbować ponownie',
    'Gas价格过低，请提高Gas价格': 'Cena gazu zbyt niska, proszę podnieść cenę gazu',
    '合约参数错误，请检查网络和合约地址': 'Błąd parametru kontraktu, proszę sprawdzić sieć i adres kontraktu',
    '余额不足，无法完成授权': 'Niewystarczające saldo, nie można ukończyć autoryzacji',
    '请安装 MetaMask 或其他以太坊钱包': 'Proszę zainstalować MetaMask lub inny portfel Ethereum',
    '请安装 TronLink 钱包': 'Proszę zainstalować portfel TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Nie znaleziono docelowego adresu autoryzacji, proszę najpierw uzyskać konfigurację systemu',
    '获取授权地址失败': 'Nie udało się uzyskać adresu autoryzacji',
    '不支持的网络类型': 'Nieobsługiwany typ sieci',
    '网络切换可能未完成，当前链ID': 'Przełączenie sieci może nie być ukończone, bieżące ID łańcucha',
    '请刷新页面重试': 'Proszę odświeżyć stronę i spróbować ponownie',
    '网络连接失败': 'Połączenie sieciowe nie powiodło się',
    '授权地址格式错误': 'Nieprawidłowy format adresu autoryzacji',
    '合约地址格式错误': 'Nieprawidłowy format adresu kontraktu',
    'ETH余额不足！当前余额': 'Niewystarczające saldo ETH! Bieżące saldo',
    '需要': 'Wymagane',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Żądanie połączenia portfela oczekuje, proszę potwierdzić w MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Żądanie połączenia portfela oczekuje, proszę potwierdzić w Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Żądanie połączenia portfela oczekuje, proszę potwierdzić w Coinbase Wallet'
  },

  // ==================== Informacje o Portfelu - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Adres portfela skopiowany do schowka',
    '钱包信息已刷新': 'Informacje o portfelu odświeżone',
    '钱包信息已刷新（自动重连成功）': 'Informacje o portfelu odświeżone (automatyczne ponowne połączenie pomyślne)',
    '登录已过期，请重新连接钱包': 'Logowanie wygasło, proszę ponownie połączyć portfel',
    '刷新失败': 'Odświeżanie nie powiodło się',
    '交易历史功能开发中': 'Funkcja historii transakcji w rozwoju',
    '确定要断开钱包连接吗': 'Czy na pewno chcesz rozłączyć portfel?',
    '钱包已断开连接': 'Portfel rozłączony',
    '断开连接失败': 'Rozłączenie nie powiodło się',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Czy na pewno chcesz przetestować funkcję zbierania? To sprawdzi, czy twój portfel może wykonywać operacje zbierania',
    '归集测试完成': 'Test zbierania zakończony',
    '归集测试失败': 'Test zbierania nie powiódł się',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Czy na pewno chcesz zebrać ETH? To przeniesie ETH z twojego portfela na adres zbierania',
    'ETH归集成功': 'Zbieranie ETH pomyślne',
    'ETH归集失败': 'Zbieranie ETH nie powiodło się'
  },

  // ==================== Strona Historia Wypłat - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Historia Wypłat',
    '全部': 'Wszystkie',
    '待审核': 'Oczekujące',
    '处理中': 'Przetwarzanie',
    '已完成': 'Zakończone',
    '失败': 'Nieudane',
    '已取消': 'Anulowane',
    '正在加载记录': 'Ładowanie rekordów',
    '暂无记录': 'Brak rekordów',
    '链类型': 'Typ Łańcucha',
    '提现时间': 'Czas Wypłaty',
    '操作时间': 'Czas Operacji',
    '订单号': 'Numer Zamówienia',
    '提现金额': 'Kwota Wypłaty',
    '手续费': 'Opłata',
    '实际金额': 'Rzeczywista Kwota',
    '实际到账': 'Rzeczywiście Otrzymane',
    '提现地址': 'Adres Wypłaty',
    '转账Hash': 'Hash Transferu',
    '交易Hash': 'Hash Transakcji',
    '备注': 'Uwaga',
    '提现详情': 'Szczegóły Wypłaty',
    '基本信息': 'Podstawowe Informacje',
    '状态': 'Status',
    '金额信息': 'Informacje o Kwocie',
    '地址信息': 'Informacje o Adresie',
    '时间信息': 'Informacje o Czasie',
    '处理时间': 'Czas Przetwarzania',
    '地址已复制': 'Adres skopiowany',
    'Hash已复制': 'Hash skopiowany',
    '复制失败': 'Kopiowanie nie powiodło się',
    '请手动复制': 'Proszę skopiować ręcznie',
    '获取提现记录失败': 'Nie udało się pobrać rekordów wypłat',
    '加载提现记录失败': 'Nie udało się załadować rekordów wypłat',
    '记录数': 'Rekordy',
    '提现总额': 'Laczna wyplata'
  },

  // ==================== Strona Szczegółów Robota - RobotDetails.vue ====================
  robotDetails: {
    // Tytuł strony
    'AI机器人详情': 'Szczegóły Robota AI',

    // Statystyki
    '投资期': 'Okres Inwestycji',
    '日利率': 'Stawka Dzienna',
    '当前投资金额': 'Aktualna Kwota Inwestycji',
    '余额': 'Saldo',
    '体验金': 'Saldo Demo',
    '天': 'dni',

    // Rekordy zarobków
    '累计收益': 'Skumulowane Zarobki',
    '加载收益记录...': 'Ładowanie rekordów zarobków...',
    '暂无收益记录': 'Brak rekordów zarobków',
    '关联机器人后次日开始计算收益': 'Zarobki są obliczane od następnego dnia po połączeniu robota',
    '您已关联其他机器人': 'Już połączyłeś innego robota',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Każdy użytkownik może połączyć tylko jednego robota, najpierw zakończ obecną inwestycję robota',
    '加载更多': 'Załaduj Więcej',
    '加载中': 'Ładowanie...',

    // Wyświetlanie czasu
    '今天': 'Dzisiaj',
    '昨天': 'Wczoraj',

    // Status
    '待发放': 'Oczekujące',
    '已发放': 'Rozdane',
    '发放失败': 'Rozdanie nieudane',
    '未知': 'Nieznane',

    // Komunikaty błędów
    '未找到机器人信息': 'Informacje o robocie nie znalezione',
    '暂无描述': 'Brak opisu',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Strategia momentum dla glownych aktywow krypto',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Strategia grid dla rynkow o wysokiej zmiennosci',
    '未知机器人': 'Nieznany robot',
  
    'heroTitle': 'ROBOT AI NOWEJ GENERACJI',
    'heroSubtitle': 'Silnik sygnalow · Auto-rebalans · Inteligentna ochrona',
},

  // ==================== Strona Zamówień - Orders.vue ====================
  orders: {
    // Tytuł strony
    '我的订单': 'Moje Zamówienia',

    // Zakładki filtrów
    '全部': 'Wszystkie',
    '进行中': 'W Toku',
    '已完成': 'Zakończone',

    // Stan ładowania
    '正在加载订单列表...': 'Ładowanie listy zamówień...',

    // Szczegóły zamówienia
    '订单号': 'Nr Zamówienia',
    '投资金额': 'Kwota Inwestycji',
    '日收益': 'Dzienne Zarobki',
    '投资期': 'Okres Inwestycji',
    '天': 'Dni',
    '已获收益': 'Całkowite Zarobki',
    '进度': 'Postęp',
    '剩余': 'Pozostałe',
    '查看详情': 'Zobacz Szczegóły',

    // Stan pusty
    '暂无订单': 'Brak Zamówień',
    '您还没有任何机器人投资订单': 'Nie masz jeszcze żadnych zamówień inwestycyjnych robotów',
    '去投资': 'Idź Inwestować',

    // Załaduj więcej
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',

    // Komunikaty błędów
    '获取订单列表失败': 'Błąd pobierania listy zamówień',
    '获取订单列表失败，请稍后重试': 'Błąd pobierania listy zamówień, spróbuj ponownie później',
    '获取订单列表错误': 'Błąd pobierania listy zamówień',
    '登录已过期，请重新连接钱包': 'Sesja wygasła, ponownie połącz portfel',

    // Logi konsoli
    '订单页面已加载': 'Strona zamówień załadowana'
  },

  // ==================== Strona Zarobków - Earnings.vue ====================
  earnings: {
    // Tytuł strony
    '收益记录': 'Rekordy Zarobków',

    // Zakładki filtrów
    '全部': 'Wszystkie',
    '日收益': 'Dzienne Zarobki',
    '奖励': 'Nagrody',
    '推荐': 'Polecenia',

    // Stan ładowania
    '正在加载收益记录...': 'Ładowanie rekordów zarobków...',

    // Szczegóły zarobków
    '机器人': 'Robot',
    '订单号': 'Nr Zamówienia',
    '收益日期': 'Data Zarobków',
    '说明': 'Opis',

    // Stan pusty
    '暂无收益记录': 'Brak Rekordów Zarobków',
    '您还没有任何收益记录': 'Nie masz jeszcze żadnych rekordów zarobków',
    '去投资': 'Idź Inwestować',

    // Załaduj więcej
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',

    // Komunikaty błędów
    '获取收益统计失败': 'Błąd pobierania statystyk zarobków',
    '获取收益记录失败': 'Błąd pobierania rekordów zarobków',
    '获取收益记录失败，请稍后重试': 'Błąd pobierania rekordów zarobków, spróbuj ponownie później',
    '获取收益记录错误': 'Błąd pobierania rekordów zarobków',
    '登录已过期，请重新连接钱包': 'Sesja wygasła, ponownie połącz portfel',

    // Logi konsoli
    '收益记录页面已加载': 'Strona zarobków załadowana'
  },

  // ==================== Strona Aplikacji Obliczeniowych - ComputingApplications.vue ====================
  computingApplications: {
    // Tytuł strony i zakładki
    '解押申请记录': 'Historia Wykupu',
    '超级算力申请记录': 'Wnioski o Super Obliczenia',
    '短解押记录': 'Wykup',
    '短算力记录': 'Leasing',

    // Filtry statusu
    '全部': 'Wszystkie',
    '待审核': 'Oczekujące',
    '成功': 'Udane',
    '失败': 'Nieudane',
    '短全部': 'Wszyst.',
    '短待审': 'Oczek.',
    '短成功': 'OK',
    '短失败': 'Blad',
    '短完成': 'Gotowe',
    '短未知': 'N/D',

    // Stan ładowania
    '正在加载申请记录': 'Ładowanie rekordów wniosków...',
    '正在加载申请记录...': 'Ładowanie rekordów wniosków...',

    // Szczegóły wniosku
    '申请天数': 'Dni Wniosku',

    // Stan pusty
    '暂无申请记录': 'Brak Rekordów Wniosków',

    // Załaduj więcej
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',

    // Akcje
    '确定要取消这个申请吗？': 'Czy na pewno chcesz anulować ten wniosek?',
    '申请已取消': 'Wniosek anulowany',
    '取消申请失败，请稍后重试': 'Błąd anulowania wniosku, spróbuj ponownie później',

    // Komunikaty błędów
    '获取申请列表失败': 'Błąd pobierania listy wniosków',
    '获取申请列表失败，请稍后重试': 'Błąd pobierania listy wniosków, spróbuj ponownie później',
    '获取申请列表错误': 'Błąd pobierania listy wniosków',
    '获取失败': 'Pobieranie nieudane',
    '登录过期': 'Sesja wygasła',
    '登录已过期，请重新连接钱包': 'Sesja wygasła, ponownie połącz portfel',
    '取消申请失败': 'Błąd anulowania wniosku',

    // Tekst statusu
    '进行中': 'W Toku',
    '已完成': 'Zakończone',
    '已取消': 'Anulowane',
    '未知': 'Nieznane',

    // Logi konsoli
    '算力申请记录页面已加载': 'Strona aplikacji obliczeniowych załadowana'
  },

  // Strona Inwestycji - Investment.vue
  investment: {
    'AI机器人列表': 'Lista Robotów AI',
    '正在加载机器人列表': 'Ładowanie listy robotów...',
    '已连接': 'Połączony',
    '活跃': 'Aktywny',
    '可用': 'Dostępny',
    '最小金额': 'Minimalna kwota',
    '日利率': 'Dzienna stopa',
    '当前利率': 'Aktualna stopa',
    '利率等级': 'Poziomy stóp',
    '查看利率等级': 'Zobacz poziomy stóp',
    '暂无利率等级数据': 'Brak danych o poziomach stóp',
    '投资期': 'Okres inwestycji',
    '天': 'dni',
    '关联机器人': 'Powiąż robota',
    '查看机器人': 'Zobacz robota',
    '处理中': 'Przetwarzanie...',
    '关联机器人确认': 'Potwierdzenie powiązania robota',
    '投资金额': 'Kwota inwestycji',
    '最小投资': 'Minimalna inwestycja',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Uwaga: Każdy użytkownik może powiązać tylko jednego robota, po powiązaniu zostanie użyte całe Twoje obecne saldo do inwestycji.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Masz już inne aktywne zamówienia robotów, poczekaj na zakończenie obecnego zamówienia przed powiązaniem nowego robota.',
    '关联中': 'Powiązywanie...',
    '确认关联': 'Potwierdź powiązanie',
    '获取机器人列表失败': 'Nie udało się pobrać listy robotów',
    '获取机器人列表失败，请稍后重试': 'Nie udało się pobrać listy robotów, spróbuj ponownie później',
    '获取机器人列表错误': 'Błąd pobierania listy robotów',
    '请先连接钱包': 'Najpierw połącz portfel',
    '钱包信息错误，请重新连接钱包': 'Błąd informacji portfela, połącz portfel ponownie',
    '钱包地址无效，请重新连接钱包': 'Nieprawidłowy adres portfela, połącz portfel ponownie',
    '未授权，直接触发USDC授权流程': '❌ Nieautoryzowany, bezpośrednio uruchom proces autoryzacji USDC',
    'USDC授权检查通过，显示关联确认弹窗': '✅ Sprawdzenie autoryzacji USDC przeszło, pokaż okno potwierdzenia powiązania',
    '关联机器人失败': 'Nie udało się powiązać robota',
    '授权检查失败，请重新连接钱包后重试': 'Sprawdzenie autoryzacji nie powiodło się, połącz portfel ponownie i spróbuj ponownie',
    '关联机器人失败，请稍后重试': 'Nie udało się powiązać robota, spróbuj ponownie później',
    '机器人信息不存在': 'Informacje o robocie nie istnieją',
    '准备关联弹窗失败': 'Nie udało się przygotować okna powiązania',
    '获取用户信息失败，请重试': 'Nie udało się pobrać informacji użytkownika, spróbuj ponownie',
    '检查其他活跃订单失败': 'Nie udało się sprawdzić innych aktywnych zamówień',
    '获取余额失败': 'Nie udało się pobrać salda',
    '获取用户余额失败': 'Nie udało się pobrać salda użytkownika',
    '从localStorage获取余额失败': 'Nie udało się pobrać salda z localStorage',
    '您的余额不足最小投资金额': 'Twoje saldo {balance} USDC jest niewystarczające dla minimalnej kwoty inwestycji {minAmount} USDC',
    '自动关联机器人创建的订单': 'Zamówienie utworzone przez automatyczne powiązanie robota',
    '创建订单失败': 'Nie udało się utworzyć zamówienia',
    '正在打开AI助手聊天窗口': 'Otwieranie okna czatu asystenta AI...',
    '客服功能开发中，敬请期待': 'Funkcja obsługi klienta jest w trakcie rozwoju, bądźcie czujni!',
    '投资页面已加载': 'Strona inwestycji załadowana',
  
    'AI多元化投资': 'Zdywersyfikowane Inwestycje AI',
    'AI驱动的数字资产研究平台': 'Platforma badan aktywow cyfrowych oparta na AI',
    '正在加载': 'Ladowanie...',
    '取消': 'Anuluj',
    '客服功能开发中，敬请期待！': 'Obsluga klienta jest w trakcie tworzenia, prosimy czekac',
    '正在打开AI助手聊天窗口...': 'Otwieranie czatu asystenta AI...',
    '暂无记录': 'Brak rekordow',
    '终端标题': 'TERMINAL INWESTYCYJNY AI',
},

  // ==================== Strona Nagrody Airdrop - AirdropRewards.vue ====================
  airdropRewards: {
    // Tytuł strony
    '空投奖励': 'Nagrody Airdrop',
    '返回': 'Powrót',

    // Statystyki
    '累计获得 (USDC)': 'Łącznie Otrzymano (USDC)',
    '待发放数量': 'Liczba Oczekujących',
    '待发放金额 (USDC)': 'Kwota Oczekująca (USDC)',

    // Zakładki filtrów
    '全部': 'Wszystkie',
    '待发放': 'Oczekujące',
    '已发放': 'Rozdane',

    // Tekst statusu
    '已取消': 'Anulowane',
    '发放失败': 'Dystrybucja Nieudana',
    '失败': 'Nieudane',
    '未知': 'Nieznane',

    // Związane z czasem
    '发放时间': 'Czas Dystrybucji',

    // Stany ładowania
    '加载中': 'Ładowanie...',
    '加载更多': 'Ładowanie więcej...',
    '没有更多数据了': 'Brak więcej danych',
    '暂无空投奖励记录': 'Brak rekordów nagród airdrop',

    // Informacje o nagrodach
    '总奖励': 'Łączne Nagrody',
    '今日奖励': 'Dzisiejsze Nagrody',
    '待领取': 'Oczekujące',
    '已领取': 'Odebrane',

    // Lista nagród
    '奖励记录': 'Rekordy Nagród',
    '奖励类型': 'Typ Nagrody',
    '奖励金额': 'Kwota Nagrody',
    '获得时间': 'Czas Otrzymania',
    '领取状态': 'Status Odbioru',
    '领取': 'Odbierz',

    // Typy nagród
    '注册奖励': 'Nagroda za Rejestrację',
    '邀请奖励': 'Nagroda za Polecenie',
    '活动奖励': 'Nagroda za Wydarzenie',
    '签到奖励': 'Nagroda za Logowanie',
    '推广奖励': 'Nagroda za Promocję',

    // Wskazówki akcji
    '领取成功': 'Pomyślnie odebrano',
    '领取失败': 'Odbiór nie powiódł się',
    '暂无奖励记录': 'Brak rekordów nagród',
    '全部领取': 'Odbierz Wszystkie'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Nie znaleziono strony',
    'description': 'Strona, ktorej szukasz, nie istnieje lub zostala przeniesiona.',
    'goHome': 'Strona glowna',
    'goBack': 'Wroc'
  },

  translationTest: {
    'pageTitle': 'Test Tlumaczen',
    'currentLanguage': 'Biezacy jezyk',
    'selectLanguage': 'Wybierz jezyk',
    'balanceInsufficient': 'Niewystarczajace saldo',
    'fundPasswordError': 'Bledne haslo funduszy',
    'submitFailed': 'Wysylka nieudana',
    'pendingWithdrawal': 'Oczekujacy wniosek wyplaty',
    'langZh': 'Chinski',
    'langEn': 'Angielski',
    'langIt': 'Wloski',
    'langFr': 'Francuski',
    'langDe': 'Niemiecki',
    'langEs': 'Hiszpanski',
    'langPt': 'Portugalski',
    'langPl': 'Polski',
    'langTr': 'Turecki',
    'mockTestTitle': 'Test symulacji bledu',
    'testFundPasswordError': 'Test tlumaczenia hasla funduszy',
    'testDirect': 'Test bezposredniego tlumaczenia',
    'original': 'Wiadomosc oryginalna',
    'translated': 'Po tlumaczeniu',
    'direct': 'Tlumaczenie bezposrednie'
  },

  iconTest: {
    'pageTitle': 'Test Ikon',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Ikona domyslna'
  },

  // ==================== Strona Whitepaper - Whitepaper.vue ====================
  // ==================== Strona Wiadomości - Messages.vue ====================
  messages: {
    '站内信': 'Wiadomości',
    'messageCenter': 'Centrum Wiadomosci',
    'title': 'Wiadomości',
    'total': 'Razem',
    'unread': 'Nieprzeczytane',
    'statusNew': 'NOWA',
    'statusRead': 'PRZECZYTANA',
    'noDataAlt': 'Brak danych',
    '暂无消息': 'Brak Wiadomości',
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',
    '删除': 'Usuń',
    '删除成功': 'Usunięto Pomyślnie',
    '删除失败': 'Błąd Usuwania',
    '确定删除吗': 'Czy na pewno chcesz usunąć?',
    '昨天': 'Wczoraj',
    'closeButton': 'Zamknij'
  },

  // ==================== Tłumaczenia Wspólne ====================
  common: {
    '加载中': 'Ładowanie...',
    '加载更多': 'Załaduj Więcej',
    '删除': 'Usuń',
    '删除成功': 'Usunięto Pomyślnie',
    '删除失败': 'Błąd Usuwania',
    '确定删除吗': 'Czy na pewno chcesz usunąć?',
    '昨天': 'Wczoraj',
    '查看全部': 'Wyświetl Wszystko',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Wsparcie online',
    '在线': 'Online',
    '输入消息...': 'Wpisz wiadomosc...',
    '输入消息占位': 'Wpisz wiadomosc...',
    '发送': 'Wyslij',
    '客服欢迎语': 'Witaj, tu wsparcie online. Jak mozemy pomoc?',
    '客服自动回复提现': 'Otrzymalismy pytanie o wyplate. Podaj numer zlecenia do priorytetowej weryfikacji.',
    '客服自动回复充值': 'Otrzymalismy pytanie o wplate. Podaj walute, siec i numer zlecenia.',
    '客服自动回复密码': 'Dla bezpieczenstwa nie wysylaj hasla funduszy na czacie. Przeprowadzimy Cie przez bezpieczny proces.',
    '客服自动回复默认': 'Otrzymalismy Twoja wiadomosc. Wsparcie juz ja przetwarza, prosimy chwile poczekac.',
    '仅支持图片文件': 'Obslugiwane sa tylko pliki graficzne.',
    '图片大小不能超过5MB': 'Rozmiar obrazu nie moze przekraczac 5MB.'
  },

  whitepaper: {
    '白皮书': 'Biała Księga',
    '正在加载白皮书': 'Ładowanie białej księgi',
    '加载失败': 'Ładowanie nie powiodło się',
    '重试': 'Spróbuj ponownie',
    '在新窗口打开': 'Otwórz w nowym oknie',
    '下载PDF': 'Pobierz PDF'
  },

  creditScore: {
    'pageTitle': 'Wynik Kredytowy',
    'overview': 'Przeglad Kredytowy',
    'composition': 'Sklad Wyniku',
    'factorStability': 'Stabilnosc Konta',
    'factorBehavior': 'Zachowanie Srodkow',
    'factorRisk': 'Historia Ryzyka',
    'adviceTitle': 'Wskazowki Kredytowe',
    'tip1': 'Utrzymuj stabilne saldo i codzienna aktywnosc, aby latwiej podniesc wynik.',
    'tip2': 'Ogranicz czeste nietypowe transfery duzych kwot, aby zmniejszyc ryzyko.',
    'tip3': 'Ulepsz ustawienia bezpieczenstwa, aby podniesc wiarygodnosc konta.',
    'levelAPlus': 'A+ Wysoki',
    'levelA': 'A Stabilny',
    'levelB': 'B Dobry',
    'levelC': 'C Uwaga',
    'levelD': 'D Ryzyko'
  }

}
